module.exports = __webpack_public_path__ + "img/weather66.103551fa.png";